import { Checkbox, Stack, Tooltip, Typography } from '@mui/material';
import { useCallback, useMemo } from 'react';
import useDataTable from '../Providers/DataTableProvider';
interface Props {
  dataTableIndex?: number;
}
export const RowSelect = ({ dataTableIndex }: Props): React.JSX.Element => {
  const { isFilterSelect, selectedData, data, totalItemCount, isRowSelected, setRowSelected, toggleAllSelected } =
    useDataTable();

  const tooltipWrap = useCallback(
    (element: React.JSX.Element) => {
      const displayCount = isFilterSelect ? totalItemCount : selectedData.length;
      const selectedCountText = <Typography>{displayCount.toString() + ' Row(s) Selected'}</Typography>;
      const content = !isFilterSelect ? (
        selectedCountText
      ) : (
        <Stack direction={'column'} alignItems={'center'}>
          <Typography>{'(All Pages)'}</Typography>
          {selectedCountText}
        </Stack>
      );

      return (
        <Tooltip arrow placement={'top-start'} title={content} disableInteractive>
          {element}
        </Tooltip>
      );
    },
    [isFilterSelect, selectedData, totalItemCount],
  );

  const checkbox = useMemo(() => {
    const isHeader = dataTableIndex === undefined;
    let isChecked: boolean;
    let isIndeterminate: boolean = false;

    if (isHeader) {
      const selectedCount = selectedData.length;
      const totalCount = data.length;
      isChecked = isFilterSelect || (totalCount > 0 && selectedCount === totalCount);
      isIndeterminate = !isFilterSelect && selectedCount > 0 && selectedCount < totalCount;
    } else {
      isChecked = isRowSelected(dataTableIndex);
    }

    return (
      <Checkbox
        color={isFilterSelect ? 'error' : 'secondary'}
        checked={isChecked}
        indeterminate={isIndeterminate}
        onChange={() => (isHeader ? toggleAllSelected() : setRowSelected(dataTableIndex, !isChecked))}
      />
    );
  }, [
    isRowSelected,
    setRowSelected,
    toggleAllSelected,
    isFilterSelect,
    dataTableIndex,
    selectedData.length,
    data.length,
  ]);

  return tooltipWrap(checkbox);
};
